import { ApisauceInstance, create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import {
  CreateUserProgramSelectedChoiceRequestObjectType,
  CreateUserProgramSelectedChoiceResponseType,
  GetAvailableProgramInstituteCoursesRequestObjectType,
  GetAvailableProgramInstituteCoursesResponseType,
  GetUserProgramSelectedChoicesRequestObjectType,
  GetUserProgramSelectedChoicesResponseType
} from './types';

import { NwProductsExtensionsServicesTypes } from '.';

type NetworkCallWithAuthType = <T>(
  api: ApisauceInstance,
  url: string,
  requestObject: unknown,
  method: string,
  options?: Record<string, unknown>
) => Promise<T>;

class NwProductsExtensionsServices
  implements NwProductsExtensionsServicesTypes
{
  api = create({
    baseURL: `${Config['NW_PRODUCTS_EXTENSIONS_BASE_URL']}`
  });
  networkCallWithAuth: NetworkCallWithAuthType;

  constructor(networkCallWithAuth: NetworkCallWithAuthType) {
    this.networkCallWithAuth = networkCallWithAuth;
  }

  getUserProgramSelectedChoices = (
    requestObject: GetUserProgramSelectedChoicesRequestObjectType
  ): Promise<GetUserProgramSelectedChoicesResponseType> => {
    return this.networkCallWithAuth(
      this.api,
      'user/program/selected_choices/v1/',
      requestObject,
      apiMethods.post
    );
  };

  createUserProgramSelectedChoice = (
    requestObject: CreateUserProgramSelectedChoiceRequestObjectType
  ): Promise<CreateUserProgramSelectedChoiceResponseType> => {
    return this.networkCallWithAuth(
      this.api,
      'user/program/choice/create/v1/',
      requestObject,
      apiMethods.post
    );
  };

  getAvailableProgramInstituteCourses = (
    requestObject: GetAvailableProgramInstituteCoursesRequestObjectType
  ): Promise<GetAvailableProgramInstituteCoursesResponseType> => {
    return this.networkCallWithAuth(
      this.api,
      `program/${requestObject.program_id}/available/institute/courses/v1/`,
      {},
      apiMethods.get
    );
  };
}

export { NwProductsExtensionsServices };
